import { dbTableCampaign } from "@dataseat-dsp-client/lib-reporter";

export const getBorMeasureMultiCampsExpr =
  dbTableCampaign.getBorMeasureMultiCampsExpr;
export const getCohortedBorMeasureMultiCampExpr =
  dbTableCampaign.getCohortedBorMeasureMultiCampExpr;
